import PropTypes from 'prop-types';

export const xstateStateMachine = PropTypes.oneOfType([
  PropTypes.shape({}),
  PropTypes.func,
]);

export const stepListProp = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  StepMachine: xstateStateMachine.isRequired,
  StepMachineOptions: PropTypes.func.isRequired,
  StepComponent: PropTypes.elementType.isRequired,
}));
